import { Badge, ErrorMessage, Spinner } from "../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../base/types";
import { IControlAttributes } from "../../../base/models";
import { useQRScannerProperties } from "./QRScannerProperties";

export const DraftQRScannerComponent: FC<IControlAttributes> = ({
    props
}) => {
    const { status, properties, error } = useQRScannerProperties(props)
    const { pageLink } = properties || {}

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <>
        <div className={"inline-block position-relative"}>
            <Badge
                className={"text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                QR Scanner
            </Badge>
            {(!pageLink?.pageId) && <>
                <p className="m-0 p-0 text-danger my-1">Page not selected.</p>
            </>}
        </div>
    </>
}